import React, { useState, useEffect } from 'react';

import ListFilialSeller from "../Filial/ListFilialSeller"
import { useParams } from "react-router-dom";
import { listarFilialSeller ,listarFilialSellerComFiltro, gerarExelFilial } from '../../../../services/http/SellerAdminstradorService/filialSellerService'
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../hooks/snackBar';
import { saveAs } from 'file-saver';

import './styles.scss';

const FilialSeller = ({ subSellerPage }) => {

    const { idEmpresa } = useParams();
    const { addSnackBar } = useSnackBar();
    const [busca, setBusca] = useState('');
    const [filialResponse, setEmpresas] = useState(
        {
            numeroPagina: 0,
            totalPaginas: 0,
            lista: [],
            tamanhoPagina: 0,
            hasPreviousPage: false,
            hasNextPage: false
        });

    const CarregarListaFilial = (pagina) => {
        trackPromise(
            listarFilialSeller(pagina, idEmpresa)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar filiais', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar filiais', info: 'error', open: true });
        })
    }

    const CarregarListaFilialComFiltro = (filtro, pagina) => {
        trackPromise(
            listarFilialSellerComFiltro(idEmpresa,filtro, pagina)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar filiais', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar filiais', info: 'error', open: true });
        })
    }

    const extrairBase = () => {
        trackPromise(
            gerarExelFilial(idEmpresa)
                .then(res => {
                    if (res.data) {
                        saveAs(res.data, "Filiais.xlsx")

                    } else {
                        addSnackBar({ message: 'Não foi possível extrair a base com filiais', info: 'warning', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano extrair a base com filiais', info: 'error', open: true });
        })
    }

    const mudarPaginaFilialSeller = (page) => {
        busca != "" ? CarregarListaFilialComFiltro(busca, page) : CarregarListaFilial(page);
    }

    const buscar = (filtro) => {
        setBusca(filtro);
    }

    useEffect(() => {
        if (busca != "") {
            const delayDebounceFn = setTimeout(() => {
                CarregarListaFilialComFiltro(busca, 1);
            }, 2000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            CarregarListaFilial(1);
        }

    }, [busca]);

    useEffect(() => {
        CarregarListaFilial(1)
    }, []);

    return (
        <div>

            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Filiais Cadastradas</h1>
            </div>

            <div className='row'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button onClick={() => subSellerPage('formulario-filial')} className="buton-green btn btn-block btn-lg mt20">
                        CADASTRAR FILIAL
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button className="buton-white-black-border btn btn-block btn-lg mt20" onClick={extrairBase}>
                        EXTRAIR BASE
                    </button>
                </div>
            </div>
            <ListFilialSeller
                subSellerPage={subSellerPage}
                response={filialResponse}
                mudarPagina={mudarPaginaFilialSeller}
                buscar={buscar}
                busca={busca}
            />

        </div>
    );
}

export default FilialSeller;